import React , {useState} from 'react'
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Modal, Box, IconButton, TextField, Tooltip, Grid } from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import MultiClientSelect from '../../../../components/DemoTabs/MultiClientSelect';
const OverTimePolicyPop = ({ open, handleClickClose }) => {
    const modalMoveActivities = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '586px',
        width: '90%',
        margin: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: '2px',
        // border: '2px solid #0B57D0'
        border: '2px solid transparent',
        backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        borderRadius: '12px',
    };
    const notificationNames = [
        {
            name: '1. Hour Before Overtime Threshold',
            type: 'Members, managers, and owners will receive an email notification'
        },
        {
            name: '2. When Member Begins Overtime',
            type: 'Members, managers, and owners will receive an email notification'
        },
    ]
    const [selectedUsers, setSelectedUsers] = useState([]);

    const users = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];

    return (
        <>

            <Modal open={open} fullWidth maxWidth="sm">
                <Box sx={{
                    ...modalMoveActivities,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '90vh',
                    overflow: 'hidden',
                }}>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                        <Box>
                            <Typography variant="h6" fontSize={'17px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Create weekly overtime policy</Typography>
                        </Box>
                        <IconButton onClick={handleClickClose} className='p-0'>
                            <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </IconButton>
                    </Box>
                    {/* End Header */}


                    {/* start Body sec  */}
                    <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '16px', paddingBottom: '0' }} dividers>
                        <Box sx={{ marginBottom: '20px' }}>
                            <Grid container spacing={1}>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Policy Name *</Typography>
                                        <TextField placeholder="Enter Policy Name" fullWidth size="small" fontWeight={400}
                                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Manrope', marginBottom: '0px' }}>Weekly Overtime</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Weekly Overtime Threshold <Tooltip title="Overtime will begin after working this many hours per week in organization's time zone" arrow placement="top" alignContent="center">
                                            <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                                <InfoOutlineIcon fontSize="small" />
                                            </button>
                                        </Tooltip></Typography>
                                        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                            <Box sx={{ width: '100%' }}>
                                                <TextField value={40} fullWidth size="small" fontWeight={400}
                                                    sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope', width: '100%' }} />
                                            </Box>
                                            <Box>
                                                <Typography sx={{ color: '#1A1F36', fontSize: '13px', fontWeight: '500' }}>Hours</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Weekly Overtime Pay Rate Multiplier </Typography>
                                        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                            <Box sx={{ width: '47%' }}>
                                                <TextField value={1.5} fullWidth size="small" fontWeight={400}
                                                    sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope', width: '100%' }} />
                                            </Box>
                                            <Box>
                                                <Typography sx={{ color: '#1A1F36', fontSize: '13px', fontWeight: '500' }}>X member’s pay rate</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Manrope' }}>
                                            Notifications
                                            <Tooltip title="Individuals who do not wish to receive these can unsubscribe at the bottom of the email" arrow placement="top" alignContent="center">
                                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                                    <InfoOutlineIcon fontSize="small" />
                                                </button>
                                            </Tooltip></Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        {
                                            notificationNames.map((items => (
                                                <Box sx={{ marginBottom: '7px' }}>
                                                    <Typography sx={{ color: '#64748B', fontSize: '14px', fontWeight: '600' }}>{items.name}</Typography>
                                                    <Typography sx={{ color: '#64748B', fontSize: '12px', fontWeight: '400' }}>{items.type}</Typography>
                                                </Box>
                                            )))
                                        }

                                    </Box>
                                </Grid>

                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Manrope' }}>
                                            Policy Members
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>
                                            Members
                                        </Typography>
                                        <Typography color='#64748B' fontWeight={400} mb={0} sx={{ fontSize: '12px', fontWeight: '400', fontFamily: 'Manrope' }}>
                                            Members can only be on 1 overtime policy at a time
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <MultiClientSelect label="Select Team Members" options={users} selectedValues={selectedUsers} onChange={setSelectedUsers} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                    {/* End Body sec  */}

                    {/* start Footer sec  */}
                    <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                        <Button onClick={handleClickClose} variant="outlined" className='bg-white text-capitalize' color="#1A1F36" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                            Cancel
                        </Button>
                        <Box display="flex" alignItems="center" sx={{ gap: '14px' }}>
                            <Button variant="contained" color="primary" className='text-capitalize' sx={{ boxShadow: 'unset', backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                    {/* End Footer sec  */}
                </Box>
            </Modal>
        </>
    )
}

export default OverTimePolicyPop